import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdsIcon, MdsIconsModule } from '@mds/icons';
import { Router } from '@angular/router';
import { ActionsHeader, BasicAppsHeader, ImportData } from '../utils/constants';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MenuService } from '@services/menu.service';
import { LoaderModule } from '@mds/ui';
import { GlobalDialogService } from '@services/global-dialog.service';
import { HeaderContainerComponent } from '@pages/dashboards/shared/header-container/header-container.component';
import { tap } from 'rxjs/operators';
import { RouterHelperService } from '@services/router-helper.service';
import { CommonAppsComponent } from '@pages/dashboards/shared/common-apps/common-apps.component';

@Component({
  selector: 'app-dashboard-apps',
  standalone: true,
  imports: [
    CommonModule,
    MdsIconsModule,
    MatSnackBarModule,
    LoaderModule,
    HeaderContainerComponent,
    CommonAppsComponent
  ],
  templateUrl: './dashboard-apps.component.html',
  styleUrls: ['./dashboard-apps.component.scss']
})
export class DashboardAppsComponent {
  protected readonly importData = ImportData;
  protected readonly icons = MdsIcon;
  private router = inject(Router);
  private menuService = inject(MenuService);
  private globalDialogService = inject(GlobalDialogService);
  private routerHelperService = inject(RouterHelperService);
  protected readonly appDetails = BasicAppsHeader;
  protected readonly actionDetails = ActionsHeader;

  loading = true;
  categories$ = this.menuService.getCategories().pipe(
    tap(() => {
      this.loading = false;
    })
  );

  onImportData(importData = null) {
    if (!importData) {
      this.globalDialogService.openImportApps();
    } else {
      this.router.navigate([importData.target]);
    }
  }

  onAppData(selectedApp: { name: string }) {
    this.routerHelperService.openAppsDialog(selectedApp.name);
  }
}
